{
  "de": {
    "milestone": {
      "actions": {
        "activate": "Aktivieren",
        "active": "Aktiv!",
        "create": "Meilenstein erstellen",
        "deactivate": "Deaktivieren",
        "delete": "Löschen",
        "delete_milestones": "Meilenstein löschen | {count} Meilensteine löschen",
        "new": "Meilenstein"
      },
      "activate": {
        "confirm": "Aktivieren",
        "intro": "Beim Aktivieren dieses Meilensteins geschieht Folgendes:",
        "past_warning": "Das Zurückgehen zu einem früheren Meilenstein macht bereits Geschehenes nicht rückgängig. Mit Kunden geteilte Inhalte werden nicht automatisch zurückgezogen.",
        "title": "Meilenstein aktivieren",
        "verb_default": "Auslösen",
        "verb_share": "Teilen"
      },
      "attach": {
        "add": "Hinzufügen",
        "add_kind": "{kind} hinzufügen",
        "assigned_tag": "Zugewiesen",
        "back": "Zurück",
        "counts": "{available} verfügbar · {assigned} bereits zugewiesen",
        "description_decision": "Entscheidungen, die der Kunde treffen muss",
        "description_survey": "Fragebögen, um Feedback zu sammeln",
        "empty": "Keine Elemente verfügbar",
        "empty_state_description": "Basierend auf Ihrem Plan können Sie {kinds} zu diesem Meilenstein hinzufügen.",
        "intro": "Wählen Sie aus, welchen Elementtyp Sie mit diesem Meilenstein verknüpfen möchten.",
        "next": "Weiter",
        "search": "Suche",
        "select_intro": "Wählen Sie die {kind} aus, die Sie hinzufügen möchten.",
        "subtitle": "Zum Meilenstein: {name}",
        "success": "Elemente wurden hinzugefügt",
        "title": "Elemente hinzufügen"
      },
      "labels": {
        "add_element": "Element hinzufügen",
        "add_kind": "{kind} hinzufügen",
        "assign_units": "Einheiten zuweisen",
        "assigned_count": "0 zugewiesen | 1 zugewiesen | {count} zugewiesen",
        "assigned_elements": "Zugewiesene Elemente",
        "assigned_empty_description": "{kinds} mit diesem Meilenstein verknüpfen",
        "assigned_empty_title": "Noch keine Elemente",
        "bulk_assign_title": "Wählen Sie die Einheiten aus, denen Sie den Meilenstein „{milestone_name}“ zuweisen möchten",
        "edit_milestone": "Meilenstein bearbeiten",
        "empty_state_subtitle": "Meilensteine machen den Bauprozess für Käufer transparenter",
        "empty_state_title": "Neuen Meilenstein erstellen",
        "finished_on": "Abgeschlossen am {date}",
        "future_milestones": "Zukünftige Meilensteine",
        "kind_decision": "Entscheidung | Entscheidungen",
        "kind_survey": "Umfrage | Umfragen",
        "kind_todo": "Aufgabe | Aufgaben",
        "milestone": "Meilenstein",
        "milestone_name": "Meilensteinname",
        "milestone_unit_count": "0 Einheiten | 1 Einheit | {count} Einheiten",
        "milestones": "Meilensteine",
        "new_milestone": "Neuer Meilenstein",
        "no_milestone": "Noch kein Meilenstein zugewiesen",
        "no_results": "Keine Meilensteine gefunden",
        "past_milestones": "Vergangene Meilensteine",
        "please_select": "Bitte wählen Sie einen neuen Meilenstein aus",
        "position": "Position",
        "search_empty_state": "Noch keine Meilensteine erstellt. Klicken Sie hier, um zu beginnen",
        "started_on": "Gestartet am {date}",
        "status_active": "Aktiv",
        "status_completed": "Abgeschlossen",
        "status_planned": "Geplant",
        "status_planned_subtitle": "Noch nicht gestartet",
        "unit_timeline_empty": "Für dieses Projekt wurden noch keine Meilensteine erstellt.",
        "units": "Einheiten",
        "units_without_milestone": "1 Einheit ohne Meilenstein | {count} Einheiten ohne Meilenstein",
        "warning_delete": "Wenn Sie einen Meilenstein löschen, der einer Einheit zugewiesen ist, verliert der Kunde den Überblick, an welchem Meilenstein sich seine Einheit befindet. Achten Sie darauf, diesen Einheiten einen neuen Meilenstein zuzuweisen!"
      },
      "toasts": {
        "bulk_assigned": "Der Meilenstein wurde erfolgreich den ausgewählten Einheiten zugewiesen",
        "create_success": "Meilenstein wurde erfolgreich erstellt",
        "deactivate_success": "Meilenstein wurde erfolgreich deaktiviert",
        "sup_assigned": "Der Meilenstein wurde erfolgreich aktiviert",
        "update_success": "Meilensteine wurden erfolgreich aktualisiert"
      },
      "validation": {
        "needName": "Name erforderlich",
        "needNamePrimary": "Der Name in der Primärsprache ({language}) ist erforderlich"
      }
    }
  }
}
